import {
  APP_INITIALIZER,
  ApplicationConfig, ErrorHandler,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, Router} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateModule} from '@ngx-translate/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideToastr} from 'ngx-toastr';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {AuthInterceptor} from "./Services/RequestInterceptor";
import * as Sentry from "@sentry/angular";
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { sentryInterceptor } from './Services/SentryInterceptor';

registerLocaleData(localeFr);


export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withXhr(), 
      withInterceptors([AuthInterceptor, sentryInterceptor])
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader(),
      })
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 10000,
      progressBar: false,
      positionClass: "toast-bottom-right-cart",
      enableHtml: true,
      closeButton: true,
    }),
    {
      provide: LOCALE_ID,
      useValue: "fr"
    },
    provideLottieOptions({player: () => player}),
    DecimalPipe
  ],
};
